/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  MicrosoftSignupRequest,
  MicrosoftSignupResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create the account behind a verified Microsoft ID token.
 * @summary Microsoft Signup
 */
export const microsoftSignup = (
    microsoftSignupRequest: MicrosoftSignupRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MicrosoftSignupResponse>(
      {url: `/auth/microsoft-signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: microsoftSignupRequest, signal
    },
      options);
    }




export const getMicrosoftSignupMutationKey = () => ['microsoftSignup'] as const;

export const getMicrosoftSignupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftSignup>>, TError,MicrosoftSignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof microsoftSignup>>, TError,MicrosoftSignupMutationVariables, TContext> => {

const mutationKey = getMicrosoftSignupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof microsoftSignup>>, MicrosoftSignupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  microsoftSignup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MicrosoftSignupMutationResult = NonNullable<Awaited<ReturnType<typeof microsoftSignup>>>
    export type MicrosoftSignupMutationBody = MicrosoftSignupRequest
    export type MicrosoftSignupMutationError = HTTPValidationError
    export type MicrosoftSignupMutationVariables = {data: MicrosoftSignupRequest}

    /**
 * @summary Microsoft Signup
 */
export const useMicrosoftSignup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftSignup>>, TError,MicrosoftSignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof microsoftSignup>>,
        TError,
        MicrosoftSignupMutationVariables,
        TContext
      > => {
      return useMutation(getMicrosoftSignupMutationOptions(options));
    }
